import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { class: "btn btn-link btn-sm" }
const _hoisted_6 = { class: "btn btn-link btn-sm" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { key: 1 }

import { computed, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import UsersTable from '@Organizations/Users/Components/UsersTable.vue'
    import { useSearchAllUsersQueryV1 } from '@Organizations/Users/queries-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DeletedUsersPage',
  setup(__props) {

    const route = useRoute()
    const tid = computed(() => Number(route.params.tid))

    const {
        runSearchAllUsersQueryV1,
        modelSearchAllUsersQueryV1: allUsersSearchResult
    } = useSearchAllUsersQueryV1(tid, '', false, false, true)

    const users = computed(() => allUsersSearchResult.value?.Users ?? [])

    onMounted(() =>
    {
        document.title = 'Deleted users'
        runSearchAllUsersQueryV1()
    })

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: tid.value }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Deleted users", -1 /* CACHED */)),
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "fa fa-users",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Active users ", -1 /* CACHED */)
          ]))])), [
            [_directive_sanitizedHref, `/#/admin/organizations/users/active/${tid.value}`]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", {
              class: "fa fa-lock",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Locked users ", -1 /* CACHED */)
          ]))])), [
            [_directive_sanitizedHref, `/#/admin/organizations/users/locked/${tid.value}`]
          ])
        ])
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_7, [
      (users.value.length)
        ? (_openBlock(), _createBlock(UsersTable, {
            key: 0,
            users: users.value
          }, null, 8 /* PROPS */, ["users"]))
        : (_openBlock(), _createElementBlock("h4", _hoisted_8, "No deleted users"))
    ])
  ]))
}
}

})